import React from "react";
import { StepShell, EyeResultRow } from "@/components/StepShell";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { CONTRAST_ROWS, CONTRAST_OPTIONS } from "@/lib/screeningData";
import { useI18n } from "@/i18n";
import { Contrast } from "lucide-react";

export const ContrastTest = ({ data, update }) => {
  const { t, tc } = useI18n();
  const c = data.contrast;
  const ContrastSelect = ({ value, onChange, testId }) => (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full sm:w-56" data-testid={testId}><SelectValue placeholder={t("ct_ph")} /></SelectTrigger>
      <SelectContent>{CONTRAST_OPTIONS.map((o) => <SelectItem key={o} value={o}>{tc(o)}</SelectItem>)}</SelectContent>
    </Select>
  );
  return (
    <StepShell icon={Contrast} title={t("ct_title")} subtitle={t("ct_sub")} testId="contrast-step">
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        <div className="bg-white px-6 py-10 flex flex-col items-center gap-6">
          {CONTRAST_ROWS.map((row) => (
            <div key={row.label} className="flex items-center justify-center w-full">
              <span className="w-16 text-right pr-4 text-xs font-mono text-slate-400 select-none">{row.label}</span>
              <span className="optotype flex-1 text-center" style={{ fontSize: "42px", color: `rgba(0,0,0,${row.opacity})` }}>{row.letters.join(" ")}</span>
              <span className="w-16" />
            </div>
          ))}
        </div>
        <div className="border-t border-slate-200 bg-slate-50 p-6">
          <p className="text-sm font-semibold text-slate-800 mb-2">{t("ct_record")}</p>
          <div className="divide-y divide-slate-200">
            <EyeResultRow label={t("eye_od")}><ContrastSelect value={c.od} onChange={(v) => update("contrast", { od: v })} testId="contrast-od-select" /></EyeResultRow>
            <EyeResultRow label={t("eye_os")}><ContrastSelect value={c.os} onChange={(v) => update("contrast", { os: v })} testId="contrast-os-select" /></EyeResultRow>
          </div>
          <div className="mt-4 space-y-1.5">
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("notes")}</Label>
            <Textarea data-testid="contrast-note-input" rows={2} value={c.note}
              onChange={(e) => update("contrast", { note: e.target.value })} placeholder={t("notes_ph")} />
          </div>
        </div>
      </div>
    </StepShell>
  );
};
